import * as api from '../api/index'

import { ALL_ANSWERS, NEW_ANSWER } from './constant'

export const getResponses = () => async (dispatch)=> {
    try {
        const { data } = await api.fetchResponses()
        dispatch({ type: ALL_ANSWERS, payload: data })
    } catch (error) {
        console.log(error)
    }
}

export const addNewResponse =(response) => async (dispatch) => {
    try {
        const { data } = await api.addResponse(response)
        dispatch({ type: NEW_ANSWER, payload: data })
    } catch (error) {
        console.log(error)
    }
}